import { z } from 'zod';
import { type DevDocumentStatus, DevDocumentStatus as DDS, type DevDocumentStatusFilter } from './-query/type';
const devDocumentStatusValues = Object.values(DDS) as [DevDocumentStatus, ...DevDocumentStatus[]];
export const DevDocumentStatusFilterSchema = z.enum(['ALL', ...devDocumentStatusValues]);

/**
 * 開発ドキュメント一覧のステータスタブ並び順。
 * ライフサイクル順 → 全件 → アーカイブ:
 *   ACTIVE → DRAFT → DEPRECATED → SUPERSEDED → ALL → ARCHIVED
 */
export const DEV_DOCUMENT_STATUS_TABS = [DDS.ACTIVE, DDS.DRAFT, DDS.DEPRECATED, DDS.SUPERSEDED, 'ALL', DDS.ARCHIVED] as const satisfies readonly DevDocumentStatusFilter[];
export function buildDevDocumentTabChangeSearch(tab: string) {
  const result = DevDocumentStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : DDS.ACTIVE,
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const
  };
}